import HomeHeader from "@/components/HomeHeader";
import Hero from "@/components/homepage/Hero";
import CallingSection from "@/components/homepage/CallingSection";
import FeaturesSection from "@/components/homepage/FeaturesSection";
import StoriesSection from "@/components/homepage/StoriesSection";
import FAQSection from "@/components/homepage/FAQSection";
import CallToAction from "@/components/homepage/CallToAction";
import Footer from "@/components/homepage/Footer";
import MicroSurvey from "@/components/homepage/MicroSurvey";
import { usePageMeta } from "@/hooks/usePageMeta";

const HOME_DESCRIPTION =
  "Christian fundraising platform for missionaries, volunteers, and church workers. Raise recurring personal support, share updates, and manage donations online with simplicity and transparency.";

export default function Home() {
  usePageMeta(undefined, HOME_DESCRIPTION);
  return (
    <div className="min-h-screen">
      <HomeHeader transparent />
      <Hero />
      <CallingSection />
      <FeaturesSection />
      <StoriesSection />
      <FAQSection />
      <CallToAction />
      <Footer />
      <MicroSurvey />
    </div>
  );
}